import { moduleProviderFactory } from 'core/providers';
import { Links } from './pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.links',
				pattern: '/links',
				isPrivate: true,
				authorization: ['linksSection.full'],
				children: [
					{
						name: 'master.app.main.links',
						pattern: '',
						component: Links,
					},
				],
			},
		],
	});
})();
